var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TopBar',{on:{"toggle-user-menu":_vm.toggleUserMenu}}),_c('SideBar'),(_vm.showUserMenu)?_c('UserMenu',{on:{"close":function($event){_vm.showUserMenu = false}}}):_vm._e(),_c('div',{staticClass:"hl_dashboard--body"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }